class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.contained = this.getAttribute('data-contained') === 'true';
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      if (this.contained) {
        this.slider.on('mounted', () => {
          this.slider.refresh();
        });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.slider) this.slider.refresh();
        });
        this.resizeObserver.observe(this);
      } else {
        this.slider.on('mounted', () => {
          this.updateSize();
        });

        // Utiliser ResizeObserver pour détecter tous les changements de taille
        this.resizeObserver = new ResizeObserver(() => {
          this.updateSize();
        });
        this.resizeObserver.observe(document.documentElement);
      }
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.hasAttribute('data-show-arrows-mobile')
      ? this.getAttribute('data-show-arrows-mobile') === 'true'
      : showArrows;
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    // Autoplay coupé si l'utilisateur limite les animations, et sous 750 px quand le slider le demande (hero).
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayMobile = this.getAttribute('data-autoplay-mobile') !== 'false';
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const autoplay = this.getAttribute('data-autoplay') === 'true' && !reducedMotion && (autoplayMobile || !isMobile);
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      snap: true,
      arrows: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: 'nearby',
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  updateSize() {
    if (this.contained) return;

    const section = this.closest('.shopify-section');
    if (!section) return;

    const rawMax = getComputedStyle(section).getPropertyValue('max-width');
    const maxPageWidth = parseFloat(rawMax);
    if (Number.isNaN(maxPageWidth)) return;

    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(section).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > maxPageWidth) {
      padding = (this.pageWidth - maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
